import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Radio,
  Typography
} from '@mui/material'
import { Fragment } from 'react'

import { FluidCapacityItem, FluidItem } from '../../../sdk'
import {
  AttributesItem,
  convertKeyValueToString
} from '../../BrowseFluidsTaxonomy/getFluidApplicationTree'
import { SelectedFluids } from './CannedJobFluidsOptions'

export const FluidsList = ({
  attributesTree,
  selected,
  handleClick
}: {
  attributesTree: {
    [key: string]: AttributesItem
  }
  selected?: SelectedFluids
  handleClick?: (
    attributesItem: AttributesItem,
    fluidItem: FluidItem,
    capacity: FluidCapacityItem | undefined
  ) => void
}) => {
  const allowSelection = !!handleClick
  return Object.values(attributesTree).map((attribute, index) => (
    <Accordion key={index} defaultExpanded>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{ bgcolor: 'primary.light' }}>
        <Typography variant="subtitle1">
          {Object.values(attribute.attributes || {}).join('; ') ||
            'No attributes'}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <List dense disablePadding>
          {Object.values(attribute.fluidItems).map((fluidItem) => {
            const primaryText = `${fluidItem.fluidItem.gradeCode} ${fluidItem.fluidItem.gradeDescription}`
            const secondaryText = `Viscosity: ${
              fluidItem.fluidItem.viscosity || 'N/A'
            } Formulation: ${
              fluidItem.fluidItem.formulation || 'N/A'
            } Temp Range: ${fluidItem.fluidItem.tempRange || 'N/A'}`
            const capacities = Object.values(fluidItem.capacities)
            return (
              <Fragment key={fluidItem.fluidItem.id!}>
                <ListItem divider selected>
                  <ListItemText
                    primary={primaryText}
                    secondary={secondaryText}
                  />
                </ListItem>
                <List component="div" dense disablePadding sx={{ ml: 2 }}>
                  {(capacities.length === 0 ||
                    capacities.flatMap((c) => c.items || []).length === 0) && (
                    <ListItem>
                      {allowSelection && (
                        <ListItemIcon>
                          <Radio
                            checked={
                              selected?.attributes === attribute.attributes &&
                              selected?.fluidItem === fluidItem.fluidItem &&
                              selected?.capacity === undefined
                            }
                            onClick={() =>
                              handleClick(
                                attribute,
                                fluidItem.fluidItem,
                                undefined
                              )
                            }
                          />
                        </ListItemIcon>
                      )}
                      <ListItemText primary={'No capacity information'} />
                    </ListItem>
                  )}
                  {capacities.map(
                    (capacity) =>
                      capacity.items &&
                      capacity.items.length > 0 && (
                        <Fragment key={capacity.id!}>
                          <ListItem divider>
                            <ListItemText
                              primary={capacity.taxonomy?.literalName || ''}
                              primaryTypographyProps={{
                                variant: 'subtitle2'
                              }}
                            />
                          </ListItem>
                          <List
                            component="div"
                            dense
                            disablePadding
                            sx={{ ml: 3 }}>
                            {capacity.groupedItems.map(
                              (capacityItem, index) => (
                                <ListItem key={index} disablePadding>
                                  {allowSelection && (
                                    <ListItemIcon>
                                      <Radio
                                        checked={
                                          selected?.attributes ===
                                            attribute.attributes &&
                                          selected?.fluidItem ===
                                            fluidItem.fluidItem &&
                                          selected?.capacity === capacityItem[0]
                                        }
                                        onChange={() =>
                                          handleClick(
                                            attribute,
                                            fluidItem.fluidItem,
                                            capacityItem[0]
                                          )
                                        }
                                      />
                                    </ListItemIcon>
                                  )}
                                  <ListItemText
                                    primary={
                                      capacityItem[0].value +
                                      ' ' +
                                      capacityItem[0].unitOfMeasure! +
                                      (capacityItem.length > 1
                                        ? ` (${capacityItem
                                            .slice(1)
                                            .map(
                                              (item) =>
                                                item.value +
                                                ' ' +
                                                item.unitOfMeasure
                                            )
                                            .join(', ')})`
                                        : '')
                                    }
                                    secondary={
                                      Object.values(
                                        capacityItem[0].extendedParameters || {}
                                      )[0] === 'Not applicable'
                                        ? ''
                                        : convertKeyValueToString(
                                            capacityItem[0].extendedParameters
                                          )
                                    }
                                  />
                                </ListItem>
                              )
                            )}
                          </List>
                        </Fragment>
                      )
                  )}
                </List>
              </Fragment>
            )
          })}
        </List>
      </AccordionDetails>
    </Accordion>
  ))
}
